module.exports = __webpack_public_path__ + "img/book-1.00b1067e.png";